import React from "react";

const items = [
  {
    title: "Անձնական Տվյալների Հավաքագրում",
    description: `ardahay.am-ը հավաքում է անձնական տվյալներ, որոնք տրամադրվում են օգտատերերի կողմից
                  Կայքի ծառայություններից օգտվելու համար:
                  Անձնական տվյալները կարող են ներառել անունը, էլեկտրոնային փոստի հասցեն,
                  հեռախոսահամարը և այլ տվյալներ, որոնք անհրաժեշտ են գրանցման,
                  հաղորդակցության կամ ծառայությունների մատուցման նպատակով:`,
    subItems: [
      `Գրանցման Տվյալներ: Երբ դուք գրանցվում եք ardarhay.am-ում,
                  մենք հավաքում ենք ձեր մուտքի տվյալները (օգտագործողի անունը, գաղտնաբառը և էլ. փոստի հասցեն):`,
      `Հաղորդակցության Տվյալներ: Ձեր էլ. փոստի հասցեն օգտագործվում է ձեզ նորություններ,
                  հատուկ թողարկումներ կամ այլ տեղեկություններ ուղարկելու համար:`,
    ],
  },
  {
    title: "Տվյալների Օգտագործում",
    description: `Մենք ձեր տվյալները օգտագործում ենք հետևյալ նպատակներով.`,
    subItems: [
      `Կայքի ծառայությունների մատուցման համար.`,
      `Օգտագործողների հետ հաղորդակցության նպատակով.`,
      `Վերլուծությունների և հետազոտությունների իրականացման համար՝ Կայքի բարելավման նպատակով:`,
    ],
  },
  {
    title: "Տվյալների Հավաքման Մեթոդներ",
    subItems: [
      `Cookies: Մենք օգտագործում ենք "cookies", որոնք թույլ են տալիս բարելավել
                    օգտատերերի փորձը և հավաքել վիճակագրական տվյալներ:
                    Եթե ցանկանում եք, կարող եք արգելափակել cookies-ները ձեր զննարկիչի կարգավորումներում,
                    սակայն որոշ ծառայություններ կարող են դառնալ անհասանելի:`,
      `Ավտոմատ Հավաքվող Տվյալներ: Երբ դուք օգտագործում եք Կայքը,
                    մենք կարող ենք ավտոմատ հավաքել որոշակի տեղեկություններ,
                    օրինակ՝ ձեր IP հասցեն, զննարկչի տեսակը, մուտքի ժամկետը և այլ տեխնիկական տվյալներ:`,
    ],
  },
  {
    title: "Տվյալների Ապահովություն",
    description: `ardahay.am-ը իրականացնում է բոլոր անհրաժեշտ տեխնիկական և կազմակերպչական միջոցները՝
                  ձեր անձնական տվյալների ապահովությունը երաշխավորելու համար:
                  Սակայն համացանցի միջոցով տվյալների փոխանցումը լիովին անվտանգ չէ, և մենք չենք կարող երաշխավորել,
                  որ տվյալները միշտ պաշտպանված կլինեն չարտոնված հասանելիությունից:`,
  },
  {
    title: "Տվյալների Փոխանցում Երրորդ Կողմերին",
    description: `Մենք չենք տրամադրում ձեր անձնական տվյալները երրորդ անձանց՝ առանց ձեր նախնական համաձայնության,
                  բացառությամբ այն դեպքերի, երբ դա պահանջվում է օրենքով կամ անհրաժեշտ է մեր ծառայությունները մատուցելու համար:`,
  },
  {
    title: "Տվյալների Պահպանման Ժամկետ",
    description: `Մենք պահպանում ենք ձեր անձնական տվյալները այնքան ժամանակ,
                  որքան անհրաժեշտ է մեր ծառայությունները մատուցելու,
                  իրավական պարտավորությունները կատարելու կամ
                  տվյալների պահպանման օրենսդրական պահանջները կատարելու համար:`,
  },
  {
    title: "Օգտագործողի Իրավունքներ",
    description: `Դուք իրավունք ունեք.`,
    subItems: [
      `Մուտք գործել և փոփոխել ձեր անձնական տվյալները.`,
      `Պահանջել ձեր տվյալների հեռացում կամ արգելափակում, եթե դրանք այլևս անհրաժեշտ չեն:`,
      `Վերցնել ձեր համաձայնությունը տվյալների մշակման համար:`,
    ],
  },
  {
    title: "Կապ մեզ հետ",
    description: `Եթե ունեք հարցեր, առաջարկություններ կամ պահանջներ կապված ձեր անձնական տվյալների մշակման հետ, 
                  կարող եք կապ հաստատել մեզ հետ հետևյալ էլ. փոստի հասցեով՝ info@ardarhay.am:
                  Այս Գաղտնիության Քաղաքականությունը վերջին անգամ թարմացվել է 2024 թ. հոկտեմբերին:`,
  },
];

const Programs = () => {
  return (
    <div className="my-36 px-10 md:px-20">
      <span className="font-bold text-[24px]">
        Գաղտնիության Քաղաքականություն
      </span>
      {items.map((item, index) => {
        return (
          <div key={index} className="mt-8">
            <span className="font-bold text-[18px]">
              {index + 1}. {item.title}
            </span>
            <p className="mt-2">{item.description}</p>
            <ul className="mt-2 list-disc list-inside">
              {item.subItems?.map((subItem, index) => {
                return <li key={index}>{subItem}</li>;
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default Programs;
